import Dotdotdot from 'react-dotdotdot'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { LanguageUtils, StateLabel, Utils } from '@pbt/pbt-ui-components'

import {
  getDiagnosisProblemStates,
  getDiagnosisStatus,
  getFindingProblemStates,
} from '~/store/reducers/constants'
import { type DiagnosisSnapshotItem, DiagnosisSnapshotItemType } from '~/types'

interface DiagnosisStatusCellProps {
  inline?: boolean
  item: DiagnosisSnapshotItem
  shorten?: boolean
}

const DiagnosisStatusCell = ({
  item,
  shorten,
  inline,
}: DiagnosisStatusCellProps) => {
  const { t } = useTranslation(['Common', 'Clients'])
  const DiagnosisStatus = useSelector(getDiagnosisStatus)
  const ProblemDiagnosisStates = useSelector(getDiagnosisProblemStates)
  const ProblemFindingStates = useSelector(getFindingProblemStates)

  const typeToStatesMap = {
    [DiagnosisSnapshotItemType.DIAGNOSIS_HISTORY]: DiagnosisStatus,
    [DiagnosisSnapshotItemType.DIAGNOSIS_LOG]: DiagnosisStatus,
    [DiagnosisSnapshotItemType.PROBLEM_DIAGNOSIS_LOG]: ProblemDiagnosisStates,
    [DiagnosisSnapshotItemType.PROBLEM_FINDING_LOG]: ProblemFindingStates,
  }
  const diagnosisStates =
    typeToStatesMap[item.type || DiagnosisSnapshotItemType.DIAGNOSIS_LOG]

  const statusDisplayName = LanguageUtils.getConstantTranslatedName(
    item.statusId,
    diagnosisStates,
  )
  const activeStatus =
    item.statusId && Utils.findById(item.statusId, diagnosisStates)

  const isHistoryRecord = !item.soapId
  let stateName = statusDisplayName

  if (isHistoryRecord) {
    stateName = shorten
      ? t('Common:PREVIOUS_CLINIC')
      : t('Clients:TIMELINE.DIAGNOSIS_CARD.RECORD_FROM_PLACE', {
          diagnosedIn: item.diagnosedIn || t('Common:PREVIOUS_CLINIC'),
        })
  }

  return (
    <Dotdotdot clamp={1}>
      <StateLabel
        {...(activeStatus?.colorVariant
          ? { [activeStatus.colorVariant]: true }
          : {})}
        inline={inline}
      >
        {stateName}
      </StateLabel>
    </Dotdotdot>
  )
}

export default DiagnosisStatusCell
